import { render, staticRenderFns } from "./Page-PointControl.vue?vue&type=template&id=d88689c6&"
import script from "./Page-PointControl.vue?vue&type=script&lang=js&"
export * from "./Page-PointControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports